import { render, staticRenderFns } from "./imageList.vue?vue&type=template&id=2b8be52c&scoped=true"
import script from "./imageList.vue?vue&type=script&lang=js"
export * from "./imageList.vue?vue&type=script&lang=js"
import style0 from "./imageList.vue?vue&type=style&index=0&id=2b8be52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8be52c",
  null
  
)

export default component.exports